import { ValueOf } from '@approvalmax/types';

export enum WarningLevel {
    None = 'none',
    Yellow = 'yellow',
    Orange = 'orange',
    Red = 'red',
    Black = 'black',
}

export interface CellWarningIndicatorProps {
    level?: ValueOf<WarningLevel>;
}
